import React from "react";
import DateRangeField from "./DateRangeField";
import {
  currentMonthRange,
  previousMonthRange,
  firstHalfRange,
  lastHalfRange,
} from "./dateRanges";

const QUICK_RANGES = [
  { label: "Eelmine kuu", fn: previousMonthRange },
  { label: "Jooksev kuu", fn: currentMonthRange },
  { label: "Esimene pool kuud", fn: firstHalfRange },
  { label: "Viimane pool kuud", fn: lastHalfRange },
];

export default function ClientsListSidebar({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,

  clients,
  selectedClientIds,
  onToggleClientTick,
  onSelectAll,
  onClearAll,
  emptyText = "Laen kliendid...",
}) {
  function applyRange(fn) {
    const { start, end } = fn();
    onStartDateChange(start);
    onEndDateChange(end);
  }

  return (
    <aside style={styles.sidebar}>
      {/* Date selection */}
      <div style={styles.section}>
        <div style={styles.title}>Kuupäev</div>

        <DateRangeField
          startDate={startDate}
          endDate={endDate}
          onChange={(s, e) => {
            onStartDateChange(s);
            onEndDateChange(e);
          }}
        />

        <div style={styles.quickRow}>
          {QUICK_RANGES.map((q) => (
            <button
              key={q.label}
              type="button"
              style={styles.quickChip}
              onClick={() => applyRange(q.fn)}
            >
              {q.label}
            </button>
          ))}
        </div>

        {(startDate || endDate) && (
          <button
            type="button"
            style={styles.clearDates}
            onClick={() => {
              onStartDateChange("");
              onEndDateChange("");
            }}
          >
            Tühjenda kuupäevad
          </button>
        )}

        <div style={styles.hint}>
          Filtreerib veod kuupäeva järgi (Algus/Lõpp). Koos ülal oleva asukoha filtriga.
        </div>
      </div>

      {/* Client selection */}
      <div style={styles.section}>
        <div style={styles.titleRow}>
          <div style={styles.title}>Tarnijad</div>

          <div style={styles.smallActions}>
            <button style={styles.tinyBtn} onClick={onSelectAll} type="button">
              Vali kõik
            </button>
            <button style={styles.tinyBtn} onClick={onClearAll} type="button">
              Tühjenda
            </button>
          </div>
        </div>

        <div style={styles.clientTickList}>
          {clients.length === 0 ? (
            <div style={styles.emptyText}>{emptyText}</div>
          ) : (
            clients.map((c) => (
              <label key={c.id} style={styles.tickRow}>
                <input
                  type="checkbox"
                  checked={selectedClientIds.has(c.id)}
                  onChange={() => onToggleClientTick(c.id)}
                />
                <span style={{ marginLeft: 10 }}>{c.name}</span>
              </label>
            ))
          )}
        </div>
      </div>
    </aside>
  );
}

/* Sidebar-only styles (kept in this file as requested) */
const styles = {
  sidebar: {
    width: "330px",
    flexShrink: 0,
    background: "white",
    borderRadius: "14px",
    padding: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    overflowY: "auto", // sidebar scrolls independently of the clients list
    boxSizing: "border-box",
  },

  section: {
    paddingBottom: "14px",
    marginBottom: "14px",
    borderBottom: "1px solid #E6ECF8",
  },

  title: {
    fontWeight: 700,
    color: "#0D1F4D",
    marginBottom: "10px",
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
    gap: 10,
  },

  label: {
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
    color: "#0D1F4D",
    marginBottom: 6,
  },

  dateInput: {
    width: "100%",
    borderRadius: "10px",
    border: "1px solid #E6ECF8",
    padding: "10px 12px",
    outline: "none",
    background: "#fff",
  },

  quickRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "10px",
  },

  quickChip: {
    flex: "1 1 calc(50% - 3px)",
    boxSizing: "border-box",
    textAlign: "center",
    whiteSpace: "nowrap",
    background: "#F3F6FD",
    border: "1px solid #E6ECF8",
    borderRadius: "999px",
    padding: "5px 10px",
    cursor: "pointer",
    fontWeight: 700,
    color: "#0D1F4D",
    fontSize: "12px",
  },

  clearDates: {
    marginTop: "10px",
    background: "#F3F6FD",
    border: "1px solid #8CA5E6",
    borderRadius: "999px",
    padding: "5px 12px",
    cursor: "pointer",
    fontWeight: 700,
    color: "#8CA5E6",
    fontSize: "12px",
  },

  hint: {
    marginTop: 10,
    fontSize: "12px",
    color: "#666",
    lineHeight: 1.35,
  },

  smallActions: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },

  tinyBtn: {
    background: "#F3F6FD",
    border: "1px solid #E6ECF8",
    borderRadius: "10px",
    padding: "6px 10px",
    cursor: "pointer",
    fontWeight: 700,
    color: "#0D1F4D",
    fontSize: "12px",
  },

  clientTickList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    paddingRight: 6,
  },

  tickRow: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    color: "#0D1F4D",
    cursor: "pointer",
  },

  emptyText: {
    fontSize: "13px",
    color: "#777",
  },
};
